export default __webpack_public_path__ + "static/media/waves-blue.3536853e.png";